<div class="content">
  <span class="description subtitle">
    <p>{{ 'AUTOMATIONS.EDITOR.TASKS.SEND_PUBLIC_SYSTEM_MESSAGE_INTERNAL.DESCRIPTION_PART_ONE' | translate }}</p>
    <p>{{ 'AUTOMATIONS.EDITOR.TASKS.SEND_PUBLIC_SYSTEM_MESSAGE_INTERNAL.DESCRIPTION_PART_TWO' | translate }}</p>
  </span>
  <glxy-form-field required="true">
    <glxy-label>
      {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_PUBLIC_SYSTEM_MESSAGE_INTERNAL.MESSAGE_BODY' | translate }}
    </glxy-label>
    <div class="input-with-variables-container">
      <textarea
        id="message-body"
        matInput
        [formControl]="messageBodyControl"
        cdkTextareaAutosize
        cdkAutosizeMinRows="4"
        cdkAutosizeMaxRows="8"
        placeholder="{{
          'AUTOMATIONS.EDITOR.TASKS.SEND_PUBLIC_SYSTEM_MESSAGE_INTERNAL.MESSAGE_BODY_PLACEHOLDER' | translate
        }}"
        [required]="true"
      ></textarea>
      <automata-automation-variable-menu
        matSuffix
        useGalaxyCompat="true"
        (variableSelected)="insertVariable('message-body', messageBodyControl, $event)"
      ></automata-automation-variable-menu>
    </div>
    <glxy-error *ngIf="messageBodyControl.hasError('required')">
      {{ 'COMMON.REQUIRED' | translate }}
    </glxy-error>
  </glxy-form-field>
  <glxy-hint class="description note">
    {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_PUBLIC_SYSTEM_MESSAGE_INTERNAL.NOTE' | translate }}
  </glxy-hint>
</div>
